<template>
  <div class="widget-wrapper">
    <div class="content-group">
      <div class="content-row">
        <div class="attack-status-wrap">
          <div class="status">
            <div
              class="info"
              @click="onClickMovePage(1, $event)"
            >
              <div class="title-wrap">
                <span
                  class="title"
                  :style="`font-size: ${headerFontSize}px`"
                >
                  Process 1
                </span>
              </div>
              <div class="detail">
                <div class="img" />
                <span :class="`sub-title ${locale}`">{{ $t('dash.secAttackState_label_reconnaissance') }}</span>
                <span
                  class="num"
                  :style="getReconnaissance.length >= 9 ? 'font-size: 12px;' : ''"
                >
                  {{ getReconnaissance }}
                </span>
              </div>
            </div>
            <div class="bar">
              <div class="dot" />
            </div>
          </div>
          <div class="status">
            <div
              class="info"
              @click="onClickMovePage(2, $event)"
            >
              <div class="title-wrap">
                <span
                  class="title"
                  :style="`font-size: ${headerFontSize}px`"
                >
                  Process 2
                </span>
              </div>
              <div class="detail">
                <div class="img" />
                <span :class="`sub-title ${locale}`">{{ $t('dash.secAttackState_label_weaponizationAndDelivery') }}</span>
                <span
                  class="num"
                  :style="getWeaponizationDelivery.length >= 9 ? 'font-size: 12px;' : ''"
                >
                  {{ getWeaponizationDelivery }}
                </span>
              </div>
            </div>
            <div class="bar">
              <div class="dot" />
            </div>
          </div>
          <div class="status">
            <div
              class="info"
              @click="onClickMovePage(3, $event)"
            >
              <div class="title-wrap">
                <span
                  class="title"
                  :style="`font-size: ${headerFontSize}px`"
                >
                  Process 3
                </span>
              </div>
              <div class="detail">
                <div class="img" />
                <span :class="`sub-title ${locale}`">{{ $t('dash.secAttackState_label_exploitation') }}</span>
                <span
                  class="num"
                  :style="getExploitation.length >= 9 ? 'font-size: 12px;' : ''"
                >
                  {{ getExploitation }}
                </span>
              </div>
            </div>
            <div class="bar">
              <div class="dot" />
            </div>
          </div>
          <div class="status">
            <div
              class="info"
              @click="onClickMovePage(4, $event)"
            >
              <div class="title-wrap">
                <span
                  class="title"
                  :style="`font-size: ${headerFontSize}px`"
                >
                  Process 4
                </span>
              </div>
              <div class="detail">
                <div class="img" />
                <span :class="`sub-title ${locale}`">{{ $t('dash.secAttackState_label_installation') }}</span>
                <span
                  class="num"
                  :style="getInstallation.length >= 9 ? 'font-size: 12px;' : ''"
                >
                  {{ getInstallation }}
                </span>
              </div>
            </div>
            <div class="bar">
              <div class="dot" />
            </div>
          </div>
          <div class="status">
            <div
              class="info"
              @click="onClickMovePage(5, $event)"
            >
              <div class="title-wrap">
                <span
                  class="title"
                  :style="`font-size: ${headerFontSize}px`"
                >
                  Process 5
                </span>
              </div>
              <div class="detail">
                <div class="img" />
                <span :class="`sub-title ${locale}`">{{ $t('dash.secAttackState_label_cmdControl') }}</span>
                <span
                  class="num"
                  :style="getCommandControl.length >= 9 ? 'font-size: 12px;' : ''"
                >
                  {{ getCommandControl }}
                </span>
              </div>
            </div>
            <div class="bar">
              <div class="dot" />
            </div>
          </div>
          <div class="status">
            <div
              class="info"
              @click="onClickMovePage(6, $event)"
            >
              <div class="title-wrap">
                <span
                  class="title"
                  :style="`font-size: ${headerFontSize}px`"
                >
                  Process 6
                </span>
              </div>
              <div class="detail">
                <div class="img" />
                <span :class="`sub-title ${locale}`">{{ $t('dash.secAttackState_label_actionsObjectives') }}</span>
                <span
                  class="num"
                  :style="getActionsObjectives.length >= 9 ? 'font-size: 12px;' : ''"
                >
                  {{ getActionsObjectives }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 페이지 이동 Confirm 팝업 -->
    <confirm-dialog
      ref="movePagePopup"
      :auth-force="true"
      :footer-btn-list="confirmBtnList"
      @onApply="onApplyMovePage"
    >
      <span class="modal-bottom-notice-text">
        <p>{{ $t('dash.widgetMovePage_msg', {'page': movePageName}) }}</p>
      </span>
    </confirm-dialog>
  </div>
</template>
<script>
import {widgetMixin} from '~/mixins/widgetCommonMixin'

import {createNamespacedHelpers} from 'vuex'
const {mapState} = createNamespacedHelpers('common/locale')
const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

export default {
  name: 'widgetSecAttackStage',
  mixins: [widgetMixin],
  data () {
    return {
      w: 2,
      title: 'widgetSecAttackStage',
      isLock: false,
      isMove: true,
      // isSync: true,
      isResize: false,
      isMaximum: false,
      // isRefresh: true,
      eventBus: true,
      deviceType: [21, 23],
      // targetPage: '/ulr/lr-integrated/lrp-integrated', 확인 필요
      targetLevel: 0,
      headerFontSize: 12,
      commonFilters: [], // 필터 설정 확인.
      widgetData: {
        exploitation: 0,
        installation: 0,
        commandControl: 0,
        reconnaissance: 0,
        actionsObjectives: 0,
        weaponizationDelivery: 0
      }
    }
  },
  computed: {
    ...mapState([
      'locale'
    ]),
    movePageName () {
      return this.$t('uda.dawRealtimeThreat_title_totalLog')
    },
    confirmBtnList () {
      return [
        {text: this.$tc('cmn.answer', 2), color: 'dark', type: 'no', authForce: true},
        {text: this.$tc('cmn.answer', 1), color: 'primary', type: 'apply', authForce: true}
      ]
    },
    getReconnaissance () {
      return this.separateByComma(this.widgetData.reconnaissance) || '0'
    },
    getWeaponizationDelivery () {
      return this.separateByComma(this.widgetData.weaponizationDelivery) || '0'
    },
    getExploitation () {
      return this.separateByComma(this.widgetData.exploitation) || '0'
    },
    getInstallation () {
      return this.separateByComma(this.widgetData.installation) || '0'
    },
    getCommandControl () {
      return this.separateByComma(this.widgetData.commandControl) || '0'
    },
    getActionsObjectives () {
      return this.separateByComma(this.widgetData.actionsObjectives) || '0'
    }
  },
  methods: {
    ...mapActions([
      'getWidgetData'
    ]),
    // setCommonFilters 로그 페이지를 이동할 때 필터 적용이 필요 함수 추가 필요.
    // ...mapMutations([
    //   'setCommonFilters'
    // ]),
    /**
     * 이름: setCommonFilters
     * 설명: 로그 페이지를 이동할 때 필터 적용이 필요 함수 추가 필요하며 추가 후 삭제 필요.
     */
    setCommonFilters (filters) {
      this.commonFilters = filters
    },
    /**
     * 이름: onApplyMovePage
     * 설명: 통합 로그 페이지로 이동한다. 항목에 따라 로그 파라미터가 다르다.
     * 차후 적용시 한글 필터 골려해야함.
     */
    onApplyMovePage () {
      if (this.targetLevel === 1) {
        this.setCommonFilters(['ckc_step=["Reconnaissance"]'])
      } else if (this.targetLevel === 2) {
        this.setCommonFilters(['ckc_step=["Weaponization and Delivery"]'])
      } else if (this.targetLevel === 3) {
        this.setCommonFilters(['ckc_step=["Exploitation"]'])
      } else if (this.targetLevel === 4) {
        this.setCommonFilters(['ckc_step=["Installation"]'])
      } else if (this.targetLevel === 5) {
        this.setCommonFilters(['ckc_step=["Command and Control"]'])
      } else {
        this.setCommonFilters(['ckc_step=["Actions on Objectives"]'])
      }
      // targetPage 확정 후 open 해야 함.
      // this.$router.push(this.targetPage)
    },
    /**
     * 이름: onClickMovePage
     * 설명: 클릭 대상에 해당하는 페이지로 이동한다.
     */
    onClickMovePage (level) {
      this.targetLevel = level
      // this.$refs.movePagePopup.show()
    },
    // 위젯 대상 장비 필터 설정.
    async onChangeWidgetMachId ({ machId }) {
      // 위젯 옵션 변경 - 저장에 필요한 값???
      this.opts.mach_id = machId
      this.getWidgetContentsData(true, machId)
    },
    /**
     * 이름: getWidgetContentsData
     * 설명: 공격 단계별 현황 데이터를 불러온다.
     */
    getCountData (stateData) {
      for (const {stage, event_count: count} of stateData) {
        if (_.includes(['Reconnaissance', '정보 수집'], stage)) {
          this.widgetData.reconnaissance = count
        } else if (_.includes(['Weaponization and Delivery', '공격 전달'], stage)) {
          this.widgetData.weaponizationDelivery = count
        } else if (_.includes(['Exploitation', '공격 수행'], stage)) {
          this.widgetData.exploitation = count
        } else if (_.includes(['Installation', '내부 침투'], stage)) {
          this.widgetData.installation = count
        } else if (_.includes(['Command and Control', '명령 제어'], stage)) {
          this.widgetData.commandControl = count
        } else if (_.includes(['Actions on Objectives', '목적 달성'], stage)) {
          this.widgetData.actionsObjectives = count
        } else {
          // 정의되지 않은 값이 들어올 경우 warning 출력
          console.warn(`[widgetSecAttackStage Data Error (${stage}: ${count})]`)
        }
      }
    },
    async getWidgetContentsData (init = false, extraParams = null) {
      const contentsOptions = {
        widgetType: 'threat_attack_stage_status'
      }

      // Progress 출력 여부
      this.showProgress(true)

      // init Flag가 True라면 기존 데이터 초기화
      if (init) {
        // 위젯 데이터 초기화
        this.widgetData = {
          exploitation: 0,
          installation: 0,
          commandControl: 0,
          reconnaissance: 0,
          actionsObjectives: 0,
          weaponizationDelivery: 0
        }
      }

      if (this.opts.ipType) {
        contentsOptions.ipType = this.opts.ipType
      }

      if (this.opts.haMember) {
        contentsOptions.dataType = this.opts.haMember
      }

      // 장비 filter 추가
      if (this.opts.mach_id) {
        contentsOptions.machId = this.opts.mach_id
      }

      // 엑스트라 파라미터가 있는 경우 (IP Type 또는 HA Mamber/Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
      if (extraParams) {
        if (extraParams.ipType) {
          contentsOptions.ipType = extraParams.ipType
        }

        if (extraParams.haMember) {
          contentsOptions.dataType = extraParams.haMember
        }

        if (extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }
      }

      // API 호출
      const {code, result = []} = await this.getWidgetData(contentsOptions)

      // Series 데이터 구성
      if (code === 'ok') {
        const stateData = result.result || []

        if (_.isEmpty(stateData)) {
          this.widgetData = {
            exploitation: 0,
            installation: 0,
            commandControl: 0,
            reconnaissance: 0,
            actionsObjectives: 0,
            weaponizationDelivery: 0
          }
        } else {
          this.getCountData(stateData)
        }
      }

      // Progress 출력 여부
      this.showProgress(false)
    }
  }
}
</script>

<style scoped>
</style>
